import Glide from '@glidejs/glide';

export const PXFeaturedProductSlider = (function () {
  'use strict';

  let sliders;

  function init() {
    sliders = document.querySelectorAll(
      '.pxblock--featured-product-slider__slider'
    );

    if (sliders.length === 0) return;

    sliders.forEach(s => {
      let sliderNavButtons = s.querySelectorAll('.glide-arrow');
      let sliderCounterCurrent = s.querySelector('.counter__current');
      let g = new Glide(s.querySelector('.glide'), {
        type: 'slider',
      }).mount();

      // set aria hidden & tabindex
      g.on('move.after', e => {
        let slideItem = jQuery(s).find('.glide__slide');

        jQuery.each(slideItem, function (i, val) {
          let item = jQuery(val);

          item.removeAttr('aria-hidden');
          item.find('button, a, input, textarea').removeAttr('tabindex');

          if (!item.hasClass('glide__slide--active')) {
            item.attr('aria-hidden', 'true');
            item.find('button, a, input, textarea').attr('tabindex', '-1');
          }
        });

        let slideItemThumbnail = jQuery(s).find('.glide__image-nav button');

        jQuery.each(slideItemThumbnail, function (i, val) {
          let item = jQuery(val);

          item.removeAttr('aria-current');

          if (item.hasClass('glide__bullet--active')) {
            item.attr('aria-current', 'true');
          }
        });
      });

      if (sliderCounterCurrent !== null) {
        g.on('run.after', ev => {
          sliderCounterCurrent.innerText = g.index + 1;
        });
      }

      sliderNavButtons.forEach(b => {
        b.addEventListener('click', function (ev) {
          let dir = this.classList.contains('glide-arrow--prev') ? '<' : '>';
          g.go(dir);
        });
      });
    });
  }

  return {
    init: init,
  };
})();
